/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EstimateList from '../../../components/projectmng/estimate/EstimateList';
import {
  listProjectEstimates,
  unloadEstimates,
} from '../../../modules/projectModule/projectEstimates';

const EstimateListContainer = ({ editFunction }) => {
  const dispatch = useDispatch();

  const { project, estimates, error, loading } = useSelector(
    ({ projectModule, loading }) => ({
      project: projectModule.project.project,
      estimates: projectModule.projectEstimates.estimates,
      error: projectModule.projectEstimates.error,
      loading: loading['project/LIST_PROJECT_ESTIMATE'],
    }),
  );

  useEffect(() => {
    if (project) {
      dispatch(listProjectEstimates(project.prjUuid));
    }
    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadEstimates());
    };
  }, [dispatch, project]);

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'qteUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'prjUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'qteNo',
        headerName: '견적서 번호',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'partnerNm',
        headerName: '거래처명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'center',
      },
      {
        field: 'qteRegDt',
        headerName: '견적일자',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'qteValidDt',
        headerName: '견적 유효일자',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'qtePrice',
        headerName: '총 견적금액',
        minWidth: 120,
        flex: 0.8,
        type: 'number',
        editable: false,
        valueFormatter: (params) => {
          const valueFormatted = Number(params).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
      {
        field: 'qteCondt',
        headerName: '수금 지급조건',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'qteKindNm',
        headerName: '견적서 종류',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'useYn',
        headerName: '사용여부',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'crtNm',
        headerName: '작성자',
        minWidth: 80,
        flex: 0.3,
        type: 'string',
        editable: false,
      },
      {
        field: 'crtDt',
        headerName: '작성일',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    editFunction(param.row);
  };

  return (
    <>
      <EstimateList
        columns={columns}
        rows={estimates}
        loading={loading}
        handleRowClick={handleRowClick}
        
		
        columnVisibilityModel={{
          id: false,
          qteUuid: false,
          prjUuid: false,
        }}

      />
    </>
  );
};

export default EstimateListContainer;
